export function getCookieConsentProvider(): 'osano' | 'cookie_yes' | 'pie_eye' {
  return 'osano'
}

export function isCookieConsentDialogVisible(): boolean {
  const provider = getCookieConsentProvider()
  if (provider === 'osano') return isOsanoConsentDialogVisible()
  if (provider === 'cookie_yes') return isCookieYesConsentDialogVisible()
  if (provider === 'pie_eye') return isPieEyeConsentDialogVisible()
  return false
}

function isOsanoConsentDialogVisible(): boolean {
  if (!document) return false
  const dialog = document.getElementsByClassName('osano-cm-dialog')?.[0]
  if (!dialog) return false
  return !dialog.classList.contains('osano-cm-dialog--hidden')
}

function isCookieYesConsentDialogVisible(): boolean {
  if (!document) return false
  const container = document.getElementsByClassName('cky-consent-container')?.[0]
  if (!container) return false
  return !container.classList.contains('cky-hide')
}

// TODO verify that this function is working. It may or may not be working.
function isPieEyeConsentDialogVisible(): boolean {
  if (!document) return false
  const container = document.getElementsByClassName('pieeye-consent-container')?.[0]
  const iFrame = container?.children[0]
  if (!iFrame) return false
  const displayValue = window.getComputedStyle(iFrame as Element).display
  const isVisible = displayValue !== 'none'
  return isVisible
}
